export default {
    namespaced: true,
    state: () => ({
        LocBaoCao: {
            TuNgay: new Date(),
            DenNgay: new Date(),
        },
    }),
    getters: {},

    mutations: {
        Set: (state, { key, data }) => {
            state[key] = data;
        },
    },

    actions: {
        LayDanhSachVeDoanhNghiepTuKhaiBao(store, NgayLoc) {
            store;
            let defaultData = {
                data: [],
                groupCount: 0,
                summary: [0],
                totalCount: 0,
            };
            var load = this.$Helper.Common.DevExDataSourceCustom(
                async (loadOptions) => {
                    this.startLoading();
                    try {
                        let resp = await this.$Core.Api.Make(
                            this.$i18n.global.t(
                                "urlBaoCao.DanhSachVeKhaiBaoNoiBo"
                            )
                        ).Post({
                            loadOptions,
                            args: NgayLoc,
                        });

                        if (resp.Data.status) {
                            let data =
                                resp.Data.data && resp.Data.data.data
                                    ? resp.Data.data
                                    : defaultData;
                            return data;
                        } else return defaultData;
                    } catch (ex) {
                        if (ex.message == "Network Error")
                            throw Error("Không kết nối được đến máy chủ!");
                        throw ex;
                    } finally {
                        this.stopLoading();
                    }
                },
                null
            );
            return load;
        },

        async LayDanhSachVeDoanhNghiepTuKhaiBaoMobile(
            store,
            { NgayLoc, skip, take }
        ) {
            try {
                let loadOptions = {
                    skip: skip,
                    take: take || 10,
                    // sort: [{ selector: "ThoiGianVao", desc: true }],
                    filter: null,
                };
                let resp = await this.$Core.Api.Make(
                    this.$i18n.global.t("urlBaoCao.DanhSachVeKhaiBaoNoiBo")
                ).Post({
                    loadOptions,
                    args: NgayLoc,
                });
                let result = [];
                if (resp.Data.status) {
                    result = resp.Data.data?.data || [];
                }
                return result || [];
            } catch (ex) {
                if (ex.message == "Network Error")
                    throw Error("Không kết nối được đến máy chủ!");
                throw ex;
            }
        },

        LayDanhSachVeKiemSoatTaiCong(store, NgayLoc) {
            store;
            let defaultData = {
                data: [],
                groupCount: 0,
                summary: [0],
                totalCount: 0,
            };
            var load = this.$Helper.Common.DevExDataSourceCustom(
                async (loadOptions) => {
                    this.startLoading();
                    try {
                        let resp = await this.$Core.Api.Make(
                            this.$i18n.global.t(
                                "urlBaoCao.DanhSachVeKiemSoatTaiCong"
                            )
                        ).Post({
                            loadOptions,
                            args: NgayLoc,
                        });

                        if (resp.Data.status) {
                            let data =
                                resp.Data.data && resp.Data.data.data
                                    ? resp.Data.data
                                    : defaultData;
                            return data;
                        } else return defaultData;
                    } catch (ex) {
                        if (ex.message == "Network Error")
                            throw Error("Không kết nối được đến máy chủ!");
                        throw ex;
                    } finally {
                        this.stopLoading();
                    }
                },
                null
            );
            return load;
        },
    },
};
